export class BalancesLabels {
  // Common
  static COMMON_HOVERDETAILBALANCES: string = "COMMON.hoverDetailBalances";
  // Summary
  static SUMMARY_HEADER: string = "SUMMARY.header";
  static SUMMARY_HEADERADA: string = "SUMMARY.headerAda";
  static SUMMARY_TOTALLONGMARKETVALUE: string = "SUMMARY.totallongmarketvalue";
  static SUMMARY_TOTALCASH: string = "SUMMARY.totalCash";
  static SUMMARY_TOTALANNUNITIES: string = "SUMMARY.totalAnnunities";
  static SUMMARY_DAYTRADINGBUYINGPOWER: string =
    "SUMMARY.dayTradingBuyingPower";
  static SUMMARY_FUNDSAVAILABLE: string = "SUMMARY.fundsAvailable";
  static SUMMARY_MARGINABLEEQUITY: string = "SUMMARY.marginableEquity";
  static SUMMARY_PREVDAYFUNDSDUE: string = "SUMMARY.prevDayFundsDue";
  static SUMMARY_TOTALACCTVAL: string = "SUMMARY.totalAcctVal";
  static SUMMARY_TRADINGFUNDS: string = "SUMMARY.tradingFunds";
  static SUMMARY_WITHDRAWALFUNDS: string = "SUMMARY.withdrawalFunds";
  static SUMMARY_NORESPONSE: string = "SUMMARY.noResponse";
  static SUMMARY_TOTALLIABILITIESBALANCE: string =
    "SUMMARY.totalLiabilitiesBalance";
  static SUMMARY_TOTALAVAILABLECREDIT: string = "SUMMARY.totalAvailableCredit";
  static SUMMARY_TAXRECLAIMRECEIVABLES: string =
    "SUMMARY.taxReclaimReceivables";
  static SUMMARY_VIEWRECEIVABLES: string = "SUMMARY.viewReceivables";
  static SUMMARY_TOOLTIP_TOTALACCOUNTVALUE: string =
    "SUMMARY.tooltip.totalAccountValue";
  static SUMMARY_TOOLTIP_LONGMARKETVALUE: string =
    "SUMMARY.tooltip.longMarketValue";
  static SUMMARY_TOOLTIP_TOTALCASH: string = "SUMMARY.tooltip.totalCash";
  static SUMMARY_TOOLTIP_TOTALACCOUNTTOOLTIPANNUITY: string =
    "SUMMARY.tooltip.totalAccountTooltipAnnuity";
  static SUMMARY_TOOLTIP_FUNDSTOWITHDRAW: string =
    "SUMMARY.tooltip.fundsToWithdraw";
  static SUMMARY_TOOLTIP_FUNDSTOTRADE: string = "SUMMARY.tooltip.fundsToTrade";
  static SUMMARY_TOOLTIP_DAYTRADINGBUYINGPOWERHOLDER: string =
    "SUMMARY.tooltip.dayTradingBuyingPowerHolder";
  static SUMMARY_TOOLTIP_FUNDSDUEHOLDER: string =
    "SUMMARY.tooltip.fundsDueHolder";
  static SUMMARY_TOOLTIP_TOTALLIABILITIESBALANCEHOLDER: string =
    "SUMMARY.tooltip.totalLiabilitiesBalanceHolder";
  static SUMMARY_TOOLTIP_TOTALAVAILABLECREDITHOLDER: string =
    "SUMMARY.tooltip.totalAvailableCreditHolder";
  static SUMMARY_TOOLTIP_CURRENTBALANCETOOLTIP: string =
    "SUMMARY.tooltip.currentBalanceToolTip";
  static SUMMARY_TOOLTIP_CREDITLIMITTOOLTIP: string =
    "SUMMARY.tooltip.creditLimitToolTip";
  static SUMMARY_TOOLTIP_AVAILABLECREDITTOOLTIP: string =
    "SUMMARY.tooltip.availableCreditToolTip";
  static SUMMARY_TOOLTIP_MARGINABLEEQUITYHOLDER: string =
    "SUMMARY.tooltip.marginableEquityHolder";
  static SUMMARY_TOOLTIP_TAXRECLAIMRECVTOOLTIP: string =
    "SUMMARY.tooltip.taxReclaimRecvTooltip";
  // Details
  static DETAIL_LABELS_HEADER: string = "DETAIL.labels.header";
  static DETAIL_LABELS_KEYVALUE: string = "DETAIL.labels.keyValue";
  static DETAIL_LABELS_KEYVALUECAP: string = "DETAIL.labels.keyValueCap";
  static DETAIL_LABELS_PERSHINGLLC: string = "DETAIL.labels.pershingLLC";
  static DETAIL_LABELS_BNYMELLONNA: string = "DETAIL.labels.bnyMellonNa";
  static DETAIL_LABELS_TODAYSCHANGE: string = "DETAIL.labels.todaysChange";
  static DETAIL_LABELS_TODAYSCHANGECAP: string =
    "DETAIL.labels.todaysChangeCap";
  static DETAIL_LABELS_BALANCESTODAYCHNG: string =
    "DETAIL.labels.balancestoday";
  static DETAIL_KEYVALUES_LONGMARKET: string = "DETAIL.keyValues.longMarket";
  static DETAIL_KEYVALUES_SHORTMARKET: string = "DETAIL.keyValues.shortMarket";
  static DETAIL_KEYVALUES_SECURITIES: string = "DETAIL.keyValues.securities";
  static DETAIL_KEYVALUES_CASHMANAGEMENT: string =
    "DETAIL.keyValues.cashManagement";
  static DETAIL_KEYVALUES_MOBILE_CASHMANAGEMENT: string =
    "DETAIL.keyValues.mobile.cashManagement";
  static DETAIL_KEYVALUES_CASH: string = "DETAIL.keyValues.cash";
  static DETAIL_KEYVALUES_NETWORTH: string = "DETAIL.keyValues.netWorth";
  static DETAIL_KEYVALUES_TOTALANNUITY: string =
    "DETAIL.keyValues.totalAnnuity";
  static DETAIL_KEYVALUES_TOTALACCOUNT: string =
    "DETAIL.keyValues.totalAccount";
  static DETAIL_CASHMANAGEMENTKEYS_OPENINGBALANCE: string =
    "DETAIL.cashManagementKeys.openingBalance";
  static DETAIL_CASHMANAGEMENTKEYS_TODAYACTIVITY: string =
    "DETAIL.cashManagementKeys.todayActivity";
  static DETAIL_CASHMANAGEMENTKEYS_MTDACCURUAL: string =
    "DETAIL.cashManagementKeys.mtdAccrual";
  static DETAIL_CASHKEYS_PRINCIPAL: string = "DETAIL.cashKeys.principal";
  static DETAIL_CASHKEYS_INCOME: string = "DETAIL.cashKeys.income";
  static DETAIL_TOTALANNUITYKEYS_TOTALVARANNUITY: string =
    "DETAIL.totalAnnuityKeys.totalVariableAnnuity";
  static DETAIL_TOTALANNUITYKEYS_TOTALFIXEDANNUITY: string =
    "DETAIL.totalAnnuityKeys.totalFixedAnnuity";
  static DETAIL_TOTALANNUITYKEYS_TOTALPENDANNUITY: string =
    "DETAIL.totalAnnuityKeys.totalPendingAnnuity";
  static DETAIL_TOOLTIPS_LONGMARKET: string =
    "DETAIL.tooltips.longMarketTooltip";
  static DETAIL_TOOLTIPS_SHORTMARKET: string =
    "DETAIL.tooltips.shortMarketTooltip";
  static DETAIL_TOOLTIPS_SECURITIES: string =
    "DETAIL.tooltips.securitiesTooltip";
  static DETAIL_TOOLTIPS_CASHMANAGEMENT: string =
    "DETAIL.tooltips.cashManagementTooltip";
  static DETAIL_TOOLTIPS_CASH: string = "DETAIL.tooltips.cashTooltip";
  static DETAIL_TOOLTIPS_NETWORTH: string = "DETAIL.tooltips.netWorthTooltip";
  static DETAIL_TOOLTIPS_TOTALANNUITY: string =
    "DETAIL.tooltips.totalAnnuityTooltip";
  static DETAIL_TOOLTIPS_TOTALACCOUNT: string =
    "DETAIL.tooltips.totalAccountTooltip";
  static DETAIL_TOOLTIPS_TOTALNETWORTHANNUITY: string =
    "DETAIL.tooltips.totalAccountTooltipAnnuity";
  static DETAIL_TOOLTIPS_OPENBALANCES: string = "DETAIL.tooltips.openBalances";
  static DETAIL_TOOLTIPS_TODAYACTIVITY: string =
    "DETAIL.tooltips.todayActivity";
  static DETAIL_TOOLTIPS_MDTACCURAL: string = "DETAIL.tooltips.mtdAccural";
  static DETAIL_TOOLTIPS_PRINCIPAL: string = "DETAIL.tooltips.principal";
  static DETAIL_TOOLTIPS_INCOME: string = "DETAIL.tooltips.income";
  // Currency
  static CURRENCY_LABELS_CURRENCYBALANCESHEADER: string =
    "CURRENCY.labels.currencyBalancesHeader";
  static CURRENCY_LABELS_ACCOUNTTYPECAP: string =
    "CURRENCY.labels.accountTypeCap";
  static CURRENCY_LABELS_BALANCETYPECAP: string =
    "CURRENCY.labels.balanceTypeCap";
  static CURRENCY_LABELS_MARKETVALUECAP: string =
    "CURRENCY.labels.marketValueCap";
  static CURRENCY_LABELS_EQUITYCAP: string = "CURRENCY.labels.equityCap";
  static CURRENCY_LABELS_EQUITYCAPM: string = "CURRENCY.labels.equityCapM";
  static CURRENCY_LABELS_EQUITYPERCENTAGECAP: string =
    "CURRENCY.labels.equityPercentageCap";
  static CURRENCY_LABELS_CASHBALANCECAP: string =
    "CURRENCY.labels.cashBalanceCap";
  static CURRENCY_LABELS_CASHBALANCECAPM: string =
    "CURRENCY.labels.cashBalanceCapM";
  static CURRENCY_LABELS_VIEWFXRATES: string = "CURRENCY.labels.viewFXRates";
  static CURRENCY_INFO_NODATA: string = "CURRENCY.info.noData";
  // Disclaimers
  static DISCLAIMER_LONGMARKETVALUE: string = "DISCLAIMERINFO.longMarketValue";
  static DISCLAIMER_SECURITYOWED: string = "DISCLAIMERINFO.securityOwed";
  static DISCLAIMER_CASHMGTINT: string = "DISCLAIMERINFO.cashMgtInt";
  static DISCLAIMER_ANNUITYVALUES: string = "DISCLAIMERINFO.annuityValues";
  static DISCLAIMER_FUNDSAVAILTOTRADE: string =
    "DISCLAIMERINFO.fundsAvailToTrade";
  static DISCLAIMER_NOTALLMARGINABLE: string =
    "DISCLAIMERINFO.notAllMarginable";
  static DISCLAIMER_CALCULATEDFUNDSDUE: string =
    "DISCLAIMERINFO.calculatedFundsDue";
  static DISCLAIMER_CASHBALANCE: string = "DISCLAIMERINFO.cashBalance";
  static DISCLAIMER_MARKETVALUE: string = "DISCLAIMERINFO.marketValue";
  static DISCLAIMER_AVAILABLECREDIT: string = "DISCLAIMERINFO.availableCredit";
  static DISCLAIMER_QUOTEDELAYED: string = "DISCLAIMERINFO.quoteDelayed";
  static DISCLAIMER_POSITIONPRICING: string = "DISCLAIMERINFO.positionsPricing";
  static DISCLAIMER_HOWFIELDSCALCULATED: string =
    "DISCLAIMERINFO.howFieldsCalculated";
  static DISCLAIMER_INFOPURPOSESONLY: string =
    "DISCLAIMERINFO.infoPurposesOnly";
  static DISCLAIMER_CREDITLIMIT: string = "DISCLAIMERINFO.creditLimit";

  static COMMON_ACCOUNT_LIMIT_ERROR: string = "COMMON.accountLimitError";
  static COMMON_SERV_UNAVAL_ERROR: string = "COMMON.serviceunavailableError";

  static OVERVIEW_SUMMARY_TOTAL_BALANCE_LABEL: string =
    "OVERVIEW_SUMMARY.TOTAL_BALANCE";
  static OVERVIEW_SUMMARY_TODAY_LABEL: string = "OVERVIEW_SUMMARY.TODAY";
  static OVERVIEW_SUMMARY_UNREALIZED_GAIN_LABEL: string =
    "OVERVIEW_SUMMARY.UNREALIZED_GAIN";
  static OVERVIEW_SUMMARY_AVAILABLE_CASH_LABEL: string =
    "OVERVIEW_SUMMARY.AVAILABLE_CASH";
  static OVERVIEW_SUMMARY_AVAILABLE_CASH_TO_TRADE_LABEL: string =
    "OVERVIEW_SUMMARY.AVAILABLE_CASH_TO_TRADE";
}
